/* eslint-disable @typescript-eslint/no-var-requires */
/** config.hooks */

import { Case, CaseImpl, caseModuleArr } from '@/interface/case.interface';
import { CardDataImpl } from '@/interface/config.interface';
import configService from '@/services/config.services';
import { SoftConfig } from '@/store/common/system';
import { definitions } from '@/types/api';

/** 基础配置-案例相关 */
const useConfigHooks = () => {
  const { listStuCaseNumber } = configService();

  const defaultCaseImg = require('@/assets/student/caseImage.png');
  const defaultCaseImg2 = require('@/assets/teacher/bgi.jpg');

  /** softConfig配置 */
  const softConfig = {
    set: (data: SoftConfig) => {
      sessionStorage.setItem('heroSoftConfig', JSON.stringify(data));
    },
    get: (): SoftConfig => JSON.parse(sessionStorage.getItem('heroSoftConfig') || '{}'),
  };

  /** 获得学生端首页-案例列表内容 —— 旧版本 */
  const getStuCaseNavList = (): Case[] => [
    new CaseImpl(
      caseModuleArr[0], // '情景构建与推演',
      '4.5',
      defaultCaseImg,
      '突发事件情景构建与推演系统以公共危机管理理论知识为基础，以案例为载体，通过构建突发事件情景与走向，让学生进行角色扮演，在已经搭建好的3D场景内进行对整个案例的风险预测、突发事件决策和决策推演。在实验过程中，需要收集相关信息，对事件进行风险评估，构建详细丰富的突发事件细节，设置事件的关键决策选择，并对选择的决策进行影响因素的评估，根据不同影响因素的变化决定突发事件的走向。',
      'HEROLEDSS',
      'HERO LEDSS.exe',
    ),
    new CaseImpl(
      caseModuleArr[1], // '风险监测预警',
      '4.5',
      defaultCaseImg2,
      '风险监测预警实训系统由四大类危机事件（自然灾害、事故灾难、公共卫生、社会安全）为载体，通过游戏化的形式模拟训练，根据风险监测预警的基本流程构成，主要包含风险评估与隐患处置、预警发布三部分。',
      'MonitoringEarlyWarning',
      'MonitoringEarlyWarning.exe',
    ),
    new CaseImpl(
      caseModuleArr[2], // '应急物资保障',
      '',
      defaultCaseImg,
      '',
      '',
      '',
    ),
    new CaseImpl(
      caseModuleArr[3], // '应急指挥调度',
      '',
      defaultCaseImg,
      '',
      '',
      '',
    ),
    new CaseImpl(
      caseModuleArr[4], // '地理信息基础管理',
      '',
      defaultCaseImg,
      '',
      '',
      '',
    ),
    new CaseImpl(
      caseModuleArr[5], // '应急决策支持',
      '',
      defaultCaseImg,
      '',
      '',
      '',
    ),
    new CaseImpl(
      caseModuleArr[6], // '应急指挥决策互动(团队)',
      '',
      defaultCaseImg,
      '',
      '',
      '',
    ),
  ];

  /**
   * 将 definitions['ExperimentCaseModuleCountResponse'][] 转为str
   */
  const getStatusList = (list: definitions['ExperimentCaseModuleCountResponse'][]): string[] => {
    const resList: {key: string; val: number}[] = [
      { key: '进行中', val: 0 },
      { key: '已结束', val: 0 },
    ];
    if (list && Array.isArray(list)) {
      list.forEach((v) => {
        if (v.status === 1) resList[0].val = (v.caseModuleCount || 0);
        if (v.status === 2) resList[1].val = (v.caseModuleCount || 0);
      });
    }

    return resList.map((v) => `${v.key}：${v.val}`);
  };
  /** 获得学生端首页卡片数据 */
  const getStuHomepageData = async (): Promise<CardDataImpl[]> => {
    const apiData = await listStuCaseNumber();
    const resList = getStuCaseNavList().map(
      (caseImpl: CaseImpl, caseImplIndex: number) => {
        const caseData = getStatusList(apiData[caseImplIndex]);
        const cardData = new CardDataImpl(caseImpl.img, caseImpl.name, caseImpl.introduce, {
          isUnLock: !caseImpl.packageName, // 如果存在包，则表示可以下载可以点
          statusList: caseData,
          caseInfo: caseImpl,
        }, undefined);
        return cardData;
      },
    );
    resList.unshift(new CardDataImpl(defaultCaseImg2, '案例分析', '案例分析', {
      isUnLock: false,
      statusList: [],
      caseInfo: new CaseImpl('案例分析', '5', defaultCaseImg2, '案例分析', 'analysisPage', 'analysisPage'),
    }, undefined));
    return resList;
  };

  /** 获得学生端 资源中心 卡片数据 */
  const getStuResourceData = async (): Promise<CardDataImpl[]> => {
    const resList = getStuCaseNavList().map(
      (caseImpl: CaseImpl) => {
        const cardData = new CardDataImpl(caseImpl.img, caseImpl.name, caseImpl.introduce, undefined, {
          isUnLock: !caseImpl.packageName, // 如果存在包，则表示可以下载可以点
          name: caseImpl.name,
          packageName: caseImpl.packageName,
          introduce: caseImpl.introduce,
        });
        return cardData;
      },
    );
    return resList;
  };
  return {
    getStuCaseNavList,
    softConfig,
    getStuHomepageData,
    getStuResourceData,
  };
};

export default useConfigHooks;
